import React, { Component } from 'react';
import { TextInput } from '../components/TextInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    journeyName: string;
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    firstname: string;
    surname: string;
    applicant: number;
    customLabel?: any;
    updateLead(props: any): void;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    firstname?: string;
    surname?: string;
}

export class CaptureName extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false, firstname: this.props.firstname, surname: this.props.surname};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep() {
        if (!this.state.firstname || !this.state.surname) {
            var errors:string[]=[];
            if (!this.state.firstname) {
                errors.push("First name is required");
            }
            if (!this.state.surname) {
                errors.push("Surname is required");
            }
            this.setState({errors: errors, hasError: true});
            return;
        }
        this.props.nextStep();
    }

    setFirstName(v: any) {
        if (this.props.applicant === 1) {
            this.props.updateLead({firstNameApplicant1: v});
        } else {
            this.props.updateLead({firstNameApplicant2: v});
        }
    }
    setSurname(v: any) {
        if (this.props.applicant === 1) {
            this.props.updateLead({surnameApplicant1: v});
        } else {
            this.props.updateLead({surnameApplicant2: v});
        }
    }

    render() {

        return (
            <header className="App-header">
                {this.props.applicant === 1 && this.props.journeyName.startsWith('Insurance') && <>
                    <h1 className='l'>Let us send you <span className='doddltext'>all the options</span><br /> with advice tailored to you</h1>
                    <h2 className='l'>No obligation, and doddl is <span className='doddltext'>100% free, always</span></h2>
                </>}
                {this.props.applicant === 1 && !this.props.journeyName.startsWith('Insurance') && <>
                    <h2 className='l'>All lenders have different rates and terms.</h2>
                    <h1 className='l'>{this.props.customLabel ?? <>Let us send you all of the options<br />with tailored advice to you.</>}</h1>
                    <h2 className='l'>No obligation, and doddl is <span className='doddltext'>100% free, always</span></h2>
                </>}
                {this.props.applicant === 2 && <>
                    <h1 className='l'>Some details about your partner</h1>
                </>}
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <TextInput
                                id='firstname'
                                value={this.props.firstname}
                                placeholder='Firstname'
                                classes={this.state.hasError && !this.state.firstname ? "e" : ""}
                                onChange={(e) => { this.setState({firstname: e.target.value}); this.setFirstName(e.target.value); }} />

                        </div>
                        <div className='column2 justify-s'>
                            <TextInput
                                id='surname'
                                value={this.props.surname}
                                placeholder='Surname'
                                classes={this.state.hasError && !this.state.surname ? "e" : ""}
                                onChange={(e) => { this.setState({surname: e.target.value}); this.setSurname(e.target.value); }} />

                        </div>
                    </div>
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
